import React from 'react'
import { Flex, Button, Action, Body } from '@dasa-health/alma-react'

type ErrorPageProps = {
  img?: {
    src: string
    alt: string
    width?: number
    heigth?: number
  }
  action: string
  body: string
  button?: {
    text?: string
    onClick?: () => void
  }
}

export const ErrorPage = ({ img, action, body, button }: ErrorPageProps) => {
  return (
    <Flex
      style={{
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%',
        alignItems: 'center',
        padding: '0 16px',
        alignContent: 'center',
        justifyContent: 'center',
        height: 'calc(100vh - 50px)',
      }}
    >
      <img
        width={img?.width ?? 196}
        height={img?.heigth}
        src={img?.src}
        alt={img?.alt}
      />
      <Action
        variant="lg"
        as="h1"
        fontSize={32}
        textAlign="center"
        lineHeight="125%"
        mt={8}
        mb={8}
      >
        {action}
      </Action>
      <Body textAlign="center" color="#666" mb={40}>
        {body}
      </Body>
      {button ? (
        <Button name="go-to-home" size="lg" onClick={button?.onClick}>
          {button?.text}
        </Button>
      ) : null}
    </Flex>
  )
}

export default ErrorPage
